export { P60ModulePage as default } from './components/P60ModulePage';
